import { __decorate, __extends } from "tslib";
import { PROPS_LIST, proxyTo, serialisable } from '../utils/FilterUtils';
import { BlurFilter } from './BlurFilter';
import { BevelTask } from './tasks/webgl/BevelTask';
import { FilterBase } from './FilterBase';
var BevelFilter = /** @class */ (function (_super) {
    __extends(BevelFilter, _super);
    function BevelFilter(options) {
        var _this = _super.call(this) || this;
        _this._blurFilter = new BlurFilter();
        _this._bevelTask = new BevelTask();
        _this.distance = 1;
        _this.angle = 45;
        _this.highlightColor = 0xffffff;
        _this.highlightAlpha = 1;
        _this.shadowColor = 1;
        _this.shadowAlpha = 0;
        _this.alphas = [];
        _this.colors = [];
        _this.ratios = [];
        _this.strength = 1;
        _this.type = 'inner';
        _this.knockout = false;
        _this.imageScale = 1;
        _this.addTask(_this._bevelTask);
        _this.applyProps(options);
        return _this;
    }
    BevelFilter.prototype.applyProps = function (model) {
        // run all model field that changed
        for (var _i = 0, _a = this[PROPS_LIST]; _i < _a.length; _i++) {
            var key = _a[_i];
            if (key in model) {
                this[key] = model[key];
            }
        }
        this._blurFilter.applyProps(model);
    };
    BevelFilter.prototype.meashurePad = function (input, target) {
        if (target === void 0) { target = input; }
        target = this._blurFilter.meashurePad(input, target);
        var offsetX = 0;
        var offsetY = 0;
        // for outer or both need render a drop shadow with valid pad
        var dist = Math.abs(this.distance);
        if (this.type !== 'inner' && dist > 0) {
            var rad = this.angle * Math.PI / 180;
            offsetX += Math.abs(Math.cos(rad)) * dist * this.imageScale * 2;
            offsetY += Math.abs(Math.sin(rad)) * dist * this.imageScale * 2;
        }
        target.x -= offsetX;
        target.y -= offsetY;
        target.width += offsetX;
        target.height += offsetY;
        return target;
    };
    BevelFilter.prototype.apply = function (source, target, sourceRect, destRect, filterManager, clearOutput) {
        if (clearOutput === void 0) { clearOutput = false; }
        var tmp = filterManager.popTemp(source.width, source.height);
        this._blurFilter.apply(source, tmp, sourceRect, tmp.rect, filterManager, true);
        this._bevelTask.sourceImage = source;
        _super.prototype.apply.call(this, tmp, target, sourceRect, destRect, filterManager, clearOutput);
        filterManager.pushTemp(tmp);
    };
    BevelFilter.prototype.setRenderState = function (source, target, sourceRect, outRect, filterManager) {
        _super.prototype.setRenderState.call(this, source, target, sourceRect, outRect, filterManager);
        this._bevelTask.inputRect.copyFrom(sourceRect);
        this._bevelTask.destRect.copyFrom(outRect);
        this._bevelTask.source = source;
        this._bevelTask.target = target;
    };
    BevelFilter.filterName = 'bevel';
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "distance", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "angle", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "highlightColor", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "highlightAlpha", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "shadowColor", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "shadowAlpha", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "alphas", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "colors", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "ratios", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "strength", void 0);
    __decorate([
        serialisable
    ], BevelFilter.prototype, "quality", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "type", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "knockout", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "imageScale", void 0);
    return BevelFilter;
}(FilterBase));
export { BevelFilter };
